export  const head = { 'fontSize': 16, 'fontWeight': 'normal'};
export  const body = { 'fontSize': 11, 'fontWeight': 'normal' };
export  const index = {'width' : 80 };
